import React from "react";
import {
  Button,
  Row,
  Col,
  CardBody,
  Collapse,
  Card,
  FormGroup,
  Input,
  Label,
  Table,
} from "reactstrap";
import NumericInput from 'react-numeric-input';
import TimePicker from "COMPONENTS/CommonComponents/TimePicker/TimePicker";

// Images
import ic_add from "ASSETS/Images/ic_add_storage.svg";
import ic_arrow_down from "ASSETS/Images/ic_arrow_down.svg";
import ic_edit from "ASSETS/Images/qr_icons/ic_edit.webp";
import ic_delete from "ASSETS/Images/qr_icons/ic_delete.webp";
import ic_check from "ASSETS/Images/check.svg";

// Constants
import {
  CONTRACT_DISPLAY_METHOD,
  DAY_OF_WEEK,
} from "UTILS/Constants";

import moment from 'moment';

import { getMessage } from "CONFIG/i18n";
import { checkEmpty } from "UTILS/Utility";

import "./SettingsPage.less"

class SupportCenterSettingsSection extends React.Component {
  constructor(props) {
    super(props);
  }

  isAddOrUpdateButtonEnabled = () => {
    // Validation of required fields.
    const requiredValid = 
      !checkEmpty(this.props.targetSkillId)
      && !checkEmpty(this.props.targetSkillName.trim())
      && this.props.targetReceptionStartTime
      && this.props.targetReceptionEndTime
      && this.props.targetContractDisplayMethod

    // Check whether the exception reception function is enabled.
    const exceptionEnabled =
      Array.isArray(this.props.targetExceptionDaysOfWeek)
      && (this.props.targetExceptionDaysOfWeek.length > 0);

    // Validation of exception reception hour.
    const exceptionHourValid = 
      this.props.targetIsReceptionDisabledOnExceptionDays
      || (this.props.targetExceptionStartTime && this.props.targetExceptionEndTime)

    // If the exception reception function is enabled, 
    // exception reception hour is required.
    return requiredValid && (!exceptionEnabled || exceptionHourValid)
  };

  render() {
    const rotate = this.props.isSupportCenterToggler ? 180 : 0;
    return (
      <>
        <div className="section">
          <Row className="noMargin">
            <Col md={11} className="mainTitle col">
              {getMessage("SUPPORT_CENTER")}
            </Col>
            <Col md={1}>
              <img
                style={{ transform: `rotate(${rotate}deg)` }}
                className="dropDown cursorPointer floatRight"
                src={ic_arrow_down}
                onClick={this.props.handleSupportCenterArrowClick}
              />
            </Col>
          </Row>
          <Collapse isOpen={this.props.isSupportCenterToggler}>
            <Row className="noMargin">
              <Col xs={6}>{getMessage("SKILLS_MANAGEMENT")}</Col>
              {!this.props.showAddSkillSection && !this.props.showUpdateSkillSection &&
                <Col xs={6} className="mainTitleStorage">
                  {/* add (+) */}
                  <img
                    src={ic_add}
                    className="cursorPointer floatRight mr-3"
                    onClick={this.props.handleAddOperatorSkillIconClick}
                    data-toggle="tooltip"
                    data-placement="top"
                    title={getMessage("ADD_SKILL")} />
                </Col>}
            </Row>
            <Row className="noMargin">
              <Col>
                <Table bordered size="sm">
                  <thead>
                    <tr className="skillHead">
                      <th className="skillRow border-bottom rounded skillCol1">
                        {getMessage("SKILL_ID")}
                      </th>
                      <th className="skillRow border-bottom rounded skillCol2">
                        {getMessage("SKILL_NAME")}
                      </th>
                      <th className="skillRow border-bottom rounded skillCol2">
                        {getMessage("RECEPTION_HOURS")}
                      </th>
                      <th className="skillRow border-bottom rounded skillCol1">
                        {getMessage("EXCEPTION")}
                      </th>
                      <th className="skillRow border-bottom rounded skillCol2">
                        {getMessage("CONTRACT_DISPLAY_METHOD")}
                      </th>
                      <th className="skillRow border-bottom rounded skillCol1">
                        {getMessage("ACTION")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.operatorSkills.map((item, index) =>
                      <tr className="cursorPointer" key={item.id}>
                        {/* ID */}
                        <td className="skillRow">
                          {item.id}
                        </td>
                        {/* skill name */}
                        <td className="skillRow">
                          {item.name}
                        </td>
                        {/* Reception time */}
                        <td className="skillRow d-flex align-items-center flex-wrap">
                          <div>{moment(item.startTime).format('HH:mm')}</div>
                          <div className='mx-2'>{getMessage("~")}</div>
                          <div>{moment(item.endTime).format('HH:mm')}</div>
                        </td>
                        <td className="skillRow">
                          {Array.isArray(item.exceptionDaysOfWeek)
                            && (item.exceptionDaysOfWeek.length > 0) &&
                            <img
                              src={ic_check}
                            />
                          }
                        </td>
                        {/* Contract information display */}
                        <td className="skillRow">
                          {getMessage(item.contractDisplayMethod)}
                        </td>
                        {/* action */}
                        <td className="skillRow">
                          {/* edit button */}
                          <img
                            src={ic_edit}
                            alt="Edit"
                            className="cursorPointer mr-2"
                            onClick={() => {
                              this.props.handleUpdateOperatorSkillClick(index, item);
                            }}
                          />
                          {/* delete button */}
                          <img
                            src={ic_delete} alt="Delete" className="cursorPointer"
                            onClick={() => {
                              this.props.handleDeleteOperatorSkillClick(index);
                            }}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
            {(this.props.showAddSkillSection || this.props.showUpdateSkillSection) &&
              <Row>
                <Col className="skillCard">
                  <Card>
                    <CardBody>
                      <Row className="radio">
                        <Col className="mainTitle"></Col>
                        <Col>
                          {/* × button */}
                          <Button
                            close aria-label="Cancel"
                            onClick={this.props.onCancelOperatorSkillClick}
                            type="button"
                          >
                          </Button>
                        </Col>
                      </Row>
                      <Row className="interCardContent">
                        <Col xs={4} className="pt-2 align-self-center">
                          <Label>{getMessage("SKILL_ID")}</Label>
                        </Col>
                        <Col xs={8}>
                          <NumericInput
                            name="targetSkillId"
                            className="inputFormControl"
                            min={0}
                            max={999}
                            required
                            onChange={(value) => {
                              this.props.handleSupportCenterNumericInputChange(
                                "targetSkillId", value, 999
                              )
                            }}
                            value={this.props.targetSkillId}
                          />
                        </Col>
                      </Row>
                      <Row className="interCardContent">
                        <Col xs={4} className="pt-2 align-self-center">
                          <Label>
                            {getMessage("SKILL_NAME")}
                          </Label>
                        </Col>
                        <Col xs={8}>
                          <Input
                            type="text"
                            name="targetSkillName"
                            className="inputFormControl"
                            maxLength="20"
                            required
                            onChange={this.props.handleSupportCenterInputChange}
                            value={this.props.targetSkillName}
                          />
                        </Col>
                      </Row>
                      <Row className="interCardContent">
                        <Col xs={4} className="pt-2 align-self-center">
                          <Label>
                            {getMessage("RECEPTION_HOURS")}
                          </Label>
                        </Col>
                        <Col
                          xs={8}
                          className="d-flex align-items-center flex-wrap receptionHours"
                        >
                          <Col xs={5} className="px-0">
                            <TimePicker
                              setTime={(time) => {
                                this.props.handleSupportCenterReceptionHoursInputChange(
                                  "targetReceptionStartTime", time
                                )
                              }}
                              value={this.props.targetReceptionStartTime}
                              placeholder={getMessage("START_TIME")}
                            />
                          </Col>
                          <Col xs={2} className="text-center">{getMessage("~")}</Col>
                          <Col xs={5} className="px-0">
                            <TimePicker
                              setTime={(time) => {
                                this.props.handleSupportCenterReceptionHoursInputChange(
                                  "targetReceptionEndTime", time
                                )
                              }}
                              value={this.props.targetReceptionEndTime}
                              placeholder={getMessage("END_TIME")}
                            />
                          </Col>
                        </Col>
                      </Row>
                      <Row className="interCardContent">
                        <Col xs={2} className="pt-2 align-self-center">
                          <Label>
                            {getMessage("EXCEPTION_HOURS")}
                          </Label>
                        </Col>
                        <Col xs={2} className="pt-2 align-self-center">
                          <FormGroup check>
                            <Label>
                              <Input
                                type="checkbox"
                                name="targetIsReceptionDisabledOnExceptionDays"
                                onChange={this.props.handleSupportCenterCheckboxChange}
                                checked={
                                  this.props.targetIsReceptionDisabledOnExceptionDays
                                }
                              />
                              {getMessage("NO_RECEPTION")}
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col
                          xs={8}
                          className={this.props.targetIsReceptionDisabledOnExceptionDays
                            ? "d-flex align-items-center flex-wrap receptionHours disabled"
                            : "d-flex align-items-center flex-wrap receptionHours"
                          }
                        >
                          <Col xs={5} className="px-0">
                            <TimePicker
                              setTime={(time) => {
                                this.props.handleSupportCenterReceptionHoursInputChange(
                                  "targetExceptionStartTime", time
                                )
                              }}
                              value={this.props.targetExceptionStartTime}
                              placeholder={getMessage("START_TIME")}
                            />
                          </Col>
                          <Col xs={2} className="text-center">{getMessage("~")}</Col>
                          <Col xs={5} className="px-0">
                            <TimePicker
                              setTime={(time) => {
                                this.props.handleSupportCenterReceptionHoursInputChange(
                                  "targetExceptionEndTime", time
                                )
                              }}
                              value={this.props.targetExceptionEndTime}
                              placeholder={getMessage("END_TIME")}
                            />
                          </Col>
                        </Col>
                      </Row>
                      <Row className="interCardContent">
                        <Col xs={2} className="pt-2">
                          <Label>
                            {getMessage("TARGET_DAYS")}:
                          </Label>
                        </Col>
                        <Col xs={10} className="pt-2 px-0 daysOfException">
                          {
                            Object.keys(DAY_OF_WEEK).map((day) =>
                              <FormGroup key={day} check inline>
                                <Label className="mb-0">
                                  <Input
                                    type="checkbox"
                                    name={day}
                                    onChange={
                                      this.props.handleSupportCenterExceptionDaysChange
                                    }
                                    checked={
                                      this.props.targetExceptionDaysOfWeek.includes(day)
                                    }
                                  />
                                  {getMessage(DAY_OF_WEEK[day])}
                                </Label>
                              </FormGroup>
                            )
                          }
                        </Col>
                      </Row>
                      <Row className="interCardContent">
                        <Col xs={4} className="pt-2 align-self-center">
                          <Label>
                            {getMessage("CONTRACT_DISPLAY_METHOD")}
                          </Label>
                        </Col>
                        <Col xs={8}>
                          <Input
                            type="select"
                            name="targetContractDisplayMethod"
                            className="inputFormControl targetContractDisplayMethodSelect"
                            onChange={this.props.handleSupportCenterInputChange}
                            value={this.props.targetContractDisplayMethod}
                          >
                            <option
                              className="inputFormControl"
                              value={CONTRACT_DISPLAY_METHOD.AUTO}
                            >
                              {getMessage(CONTRACT_DISPLAY_METHOD.AUTO)}
                            </option>
                            <option
                              className="inputFormControl"
                              value={CONTRACT_DISPLAY_METHOD.MANUAL}
                            >
                              {getMessage(CONTRACT_DISPLAY_METHOD.MANUAL)}
                            </option>
                          </Input>
                        </Col>
                      </Row>
                      {this.props.skillErrorMessage !== "" ?
                        <Row>
                          <Col md={12} className="errors autoHeight">
                            {this.props.skillErrorMessage}
                          </Col>
                        </Row>
                        : null
                      }
                      <Row className="interCardContent floatRight mx-2">
                        <Button
                          className={
                            this.isAddOrUpdateButtonEnabled()
                              ? "borderBtn cursorPointer bgwhite px-4 mx-1 mt-2"
                              : "borderBtn cursorPointer bgwhite px-4 mx-1 mt-2 isDisabled"
                          }
                          onClick={this.props.handleAddOperatorSkillClick}
                        >
                          {this.props.showUpdateSkillSection
                            ? getMessage("UPDATE") : getMessage("ADD")}
                        </Button>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            }
          </Collapse>
        </div>
      </>
    )
  }
}
export default SupportCenterSettingsSection;